import { atom } from 'recoil'
import { IProtectionDayByIdResponse } from 'screens/Protection/protection.types'

const protectionDayAtom = atom<IProtectionDayByIdResponse | null>({
  key: 'protectionDay',
  default: null,
})

export default protectionDayAtom
